<template>
  <a
    href="#"
    class="order-button"
    title="Order Online!"
    @click.prevent="showOrderSystem"
    :style="buttonCustom"
  >
    {{ $t("label.order_online") }}
  </a>
</template>

<script>
import PostMessages from "@/services/PostMessages";
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters({
      themeColor: "getThemeColor",
      textColor: "getTextColor",
      business: "getBusiness"
    }),
    buttonCustom() {
      let styles = "";

      if (this.themeColor) {
        styles += `background-color: ${this.themeColor};`;
      }

      if (this.textColor) {
        styles += `color: ${this.textColor};`;
      }

      return styles;
    }
  },
  methods: {
    showOrderSystem() {
      const messages = new PostMessages("showOrderSystem");
      messages.send();
    }
  }
};
</script>

<style lang="scss" scoped>
.order-button {
  cursor: pointer;
  border-radius: 100px;
  font-size: 1rem;
  color: #fff;
  text-decoration: none;
  padding: 0.7rem 1.6rem;
  background: #007bff;
  transition: all 0.4s ease-out;
  display: inline-block;
  text-align: center;

  &:hover {
    opacity: 0.8;
    color: #fff;
  }
}
</style>
